import { API_BASE_URL } from '../config/api';

// Convert a stored media reference (legacy `/uploads/...` path or full https URL)
// into a fully-qualified URL the browser can load.
//
// - Absolute URLs (http://, https://, data:, blob:) — returned unchanged.
// - Legacy local paths (/uploads/...) — prefixed with the API base URL.
// - Anything else (null/empty/relative) — returned unchanged.
export const resolveMediaUrl = (src) => {
  if (!src || typeof src !== 'string') return src;
  if (src.startsWith('http://') || src.startsWith('https://')) return src;
  if (src.startsWith('data:') || src.startsWith('blob:')) return src;
  if (src.startsWith('/uploads/')) return `${API_BASE_URL}${src}`;
  return src;
};

// Whether a value looks like a real uploaded asset (Supabase URL or legacy local path),
// as opposed to null/placeholder/external icon. Used by product/wishlist/cart UIs to
// decide whether to render an <img> or a fallback emoji.
export const isUploadedAsset = (src) => {
  if (!src || typeof src !== 'string') return false;
  return src.startsWith('/uploads/')
    || src.startsWith('http://')
    || src.startsWith('https://');
};

export default resolveMediaUrl;
